import React, { useState } from 'react';
import { renderIcon } from '../../utils/iconHelper';

interface WidgetToggleProps {
  onClick: () => void;
  icon?: React.ReactNode | string;
  customStyles?: React.CSSProperties;
}

export const WidgetToggle: React.FC<WidgetToggleProps> = ({
  onClick,
  icon,
  customStyles = {},
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const hoverStyles: React.CSSProperties = isHovered ? {
    transform: 'scale(1.1)',
    boxShadow: '0 6px 20px rgba(79, 70, 229, 0.5)',
  } : {};

  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        ...customStyles,
        ...hoverStyles,
      }}
      aria-label="Abrir chat"
      type="button"
    >
      {renderIcon(icon, undefined, true)}
    </button>
  );
};
